export default __webpack_public_path__ + "static/smsc_logo-8e53890a9fff5027464703b7e9ae1960.png";